import { requestEnvelope } from './client'
import { paginated, triggerSchema } from './schemas'
import type { TriggerFilter } from '../lib/query-keys'

export async function listTriggers(f: TriggerFilter) {
  const params = new URLSearchParams({
    page: String(f.page ?? 1),
    pageSize: String(f.pageSize ?? 20),
  })
  if (f.eventId) params.set('eventId', f.eventId)
  const data = await requestEnvelope(`/triggers?${params.toString()}`, paginated(triggerSchema))
  return data
}
